'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var CID = require('cids');

var multiaddr = require('multiaddr');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var _require = require('./response-types'),
    Provider = _require.Provider;

module.exports = configure(function (api) {
  /**
   * @type {import('..').ImplementsMethod<'findProvs', import('ipfs-core/src/components/dht')>}
   */
  function findProvs(_x) {
    return _findProvs.apply(this, arguments);
  }

  function _findProvs() {
    _findProvs = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
      var options,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          message,
          _iterator2,
          _step2,
          _step2$value,
          ID,
          Addrs,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return _awaitAsyncGenerator(api.post('dht/findprovs', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: "".concat(new CID(cid))
                }, options)),
                headers: options.headers
              }));

            case 3:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 6;
              _iterator = _asyncIterator(res.ndjson());

            case 8:
              _context.next = 10;
              return _awaitAsyncGenerator(_iterator.next());

            case 10:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 14;
              return _awaitAsyncGenerator(_step.value);

            case 14:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 38;
                break;
              }

              message = _value;

              if (!(message.Type === Provider && message.Responses)) {
                _context.next = 35;
                break;
              }

              _iterator2 = _createForOfIteratorHelper(message.Responses);
              _context.prev = 19;

              _iterator2.s();

            case 21:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 27;
                break;
              }

              _step2$value = _step2.value, ID = _step2$value.ID, Addrs = _step2$value.Addrs;
              _context.next = 25;
              return {
                id: ID,
                addrs: (Addrs || []).map(function (a) {
                  return multiaddr(a);
                })
              };

            case 25:
              _context.next = 21;
              break;

            case 27:
              _context.next = 32;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](19);

              _iterator2.e(_context.t0);

            case 32:
              _context.prev = 32;

              _iterator2.f();

              return _context.finish(32);

            case 35:
              _iteratorNormalCompletion = true;
              _context.next = 8;
              break;

            case 38:
              _context.next = 44;
              break;

            case 40:
              _context.prev = 40;
              _context.t1 = _context["catch"](6);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 44:
              _context.prev = 44;
              _context.prev = 45;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 49;
                break;
              }

              _context.next = 49;
              return _awaitAsyncGenerator(_iterator.return());

            case 49:
              _context.prev = 49;

              if (!_didIteratorError) {
                _context.next = 52;
                break;
              }

              throw _iteratorError;

            case 52:
              return _context.finish(49);

            case 53:
              return _context.finish(44);

            case 54:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 40, 44, 54], [19, 29, 32, 35], [45,, 49, 53]]);
    }));
    return _findProvs.apply(this, arguments);
  }

  return findProvs;
});